import { FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent implements OnInit {

  @Input() data: any[];
  @Input("control") formControl: FormControl;
  @Input() displayField: string;
  @Input() placeholder: string;
  @Input() appearance: string;
  @Input() floatLabel: string;
  @Input() includeAllOption: boolean;
  @Input() useTranslate: boolean;

  @Output() valueChange = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  valueChanged(event) {
    if (this.valueChange) {
      this.valueChange.emit(event);
    }
  }

}
